import { Grid2, Typography } from "@mui/material"
import CustomCheckbox from "./CustomCheckbox";
import { ActionCheckLabel } from "../../Overview/components/StyledComponents";

const ActionChecklistItem = ({isChecked = false, label, onChange}) => {
    return (
        <Grid2
            container
            gap={2.5}
            sx={{
                border: '1px solid #EAEAEA',
                borderRadius: '4px',
                py: 1.5,
                px: 2,
                alignItems: 'center'
            }}
        >
            <ActionCheckLabel
                disabled={false}
                control={
                    <CustomCheckbox
                        variant="light"
                        checked={isChecked}
                        onChange={onChange}
                    />
                }
                label={<Typography variant="fw400s14lh20c2E2E2E" sx={{ml: 2.5}}>{label}</Typography>}
            />
        </Grid2>
    )
}

export default ActionChecklistItem;
